'use client';

import { useAbFlag } from '@flipster/features/src/shared/ab-test';
import { useAuth } from '@flipster/features/src/shared/auth/state';
import { TvChartWeb, TvScript } from '@flipster/tvchart';

interface Props {
  symbol: string;
  isSpot: boolean;
}

export const Chart = ({ symbol, isSpot }: Props) => {
  const { isLoggedIn } = useAuth();
  const isSpotLimitOrderEnabled = useAbFlag('25q4-spot-limit-order', 'on');

  return (
    <>
      <TvScript />
      <TvChartWeb
        symbol={symbol}
        isSpot={isSpot}
        isLoggedIn={isLoggedIn}
        featureFlags={{
          '25q4-spot-limit-order': isSpotLimitOrderEnabled,
        }}
      />
    </>
  );
};
